import { SET_MESSAGES, MARK_MESSAGE_AS_READ } from "../constants/messages";

const initialValue = [];

export default (state = initialValue, action) => {
  const newState = [...state];

  switch (action.type) {
    case SET_MESSAGES:
      return action.payload;
    case MARK_MESSAGE_AS_READ:
      const messageIndex = newState.findIndex(
        (msg) => msg.messageId === action.payload,
      );
      if (messageIndex !== -1) {
        newState[messageIndex] = {
          ...newState[messageIndex],
          read: true,
        };
      }
      return newState;
    default:
      return state;
  }
};
